import { toast } from 'react-toastify'
import { format } from 'react-string-format'
import { ToastType } from '../types/generalType'
import { t } from 'i18next'

const toastify = (
  type: ToastType,
  data: { operatin?: string; pageName?: string; toastMessage?: string },
) => {
  const message: string = data.toastMessage
    ? data.toastMessage
    : format(t('toastMessage'), data?.operatin as string, data?.pageName as string)
  switch (type) {
    case ToastType.SUCCESS:
      toast.success(message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      })
      break
    case ToastType.ERROR:
      toast.error(message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      })
      break
    case ToastType.TopCenter:
      toast.success(message, {
        position: 'top-center',
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      })
      break
    default:
      break
  }
}

export default toastify
